import React, { useState } from "react";
import {
    useDeleteBankAccountMutation,
    useGetBankAccountsQuery,
} from "../Service/bankAccountsApi";

import { BankAccountsRoutes } from "../../../Router/path";
import { useNavigate } from "react-router-dom";
import CustomCard from "../../Shared/Components/CustomCard/CustomCard";
import { Box } from "@mui/system";
import { Typography } from "@mui/material";
import ActionButtons from "../../Shared/Components/ActionButtons";
import InfoIcon from "@mui/icons-material/Info";
import DataTable from "../../Shared/Components/DataTable";
import { columnBankAccounts } from "../columns";
import Status from "../../Shared/Components/Status/Status";
import EmptyState from "../../Shared/Components/EmptyState/EmptyState";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import theme from "../../../theme";
import { useDeleteSelectedItems } from '../../Shared/Hooks/useDeleteSelectedItems';
import { useCreateRedirect } from '../../Shared/Hooks/useCreateRedirect';

const BankAccounts = () => {
    const [selectedBankAccountsIds, setSelectedBankAccountsIds] = useState<
        number[]
    >([]);
    const { data, isLoading, isError, error } = useGetBankAccountsQuery();
    const [deleteBankAccount, statusDelete] = useDeleteBankAccountMutation();

    const handleDeleteSelected = useDeleteSelectedItems<number>(
        selectedBankAccountsIds,
        (id) => deleteBankAccount(id).unwrap(),
        () => setSelectedBankAccountsIds([])
    );

    const handleCreate = useCreateRedirect(BankAccountsRoutes.create);
    const navigate = useNavigate();
    return (
        <>
            <CustomCard
                icon={<InfoIcon fontSize="large" color="primary" />}
                title="Konta bankowe własne"
                subheader="Zarządzaj dostępnymi kontami bankowymi w systemie"
                sx={{ mb: 4 }}
            >
                <Box sx={{ mb: 2 }}>
                    <Typography variant="body1" gutterBottom>
                        Na tej stronie możesz dodać, edytować konta bankowe własne. Aby
                        opublikować konto bankowe, najpierw musisz wprowadzić podstawowe
                        informacje.
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Skorzystaj z przycisków poniżej, żeby dodać nowe konto bankowe,
                        usunąć zaznaczone lub wybierz konto z listy, aby je edytować.
                    </Typography>
                </Box>
                <ActionButtons
                    onCreate={handleCreate}
                    onDeleteSelected={handleDeleteSelected}
                />
            </CustomCard>
            <CustomCard>
                {data?.length === 0 ? (
                    <EmptyState
                        message="Brak kont bankowych"
                        desc="Dodaj pierwsze konto bankowe, aby zobaczyć je na liście."
                        icon={<AccountBalanceIcon sx={{ fontSize: 50, color: theme.palette.primary.main }} />}
                    />
                ) : (
                    <DataTable
                        columns={columnBankAccounts}
                        data={data || []}
                        isLoading={isLoading}
                        isError={isError}
                        errorMessage={(error as any)?.data?.message}
                        getRowId={(row) => row.id}
                        onEdit={(id) => {
                            const item = data?.find((item) => item.id === id);
                            if (item) {
                                navigate(
                                    BankAccountsRoutes.update.replace(
                                        ":bankAccountId",
                                        item.id.toString()
                                    )
                                );
                            }
                        }}
                        selected={selectedBankAccountsIds}
                        onSelectionChange={(selectedIds) => {
                            setSelectedBankAccountsIds(selectedIds);
                        }}
                    />
                )}
            </CustomCard>
            <Status statusDelete={statusDelete} />
        </>
    );
};

export default BankAccounts;
